#content
<template>
	<div class="content-wrapper" v-if="isloaded">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="position-relative w-100 sf-col sf-col-20">
				<buttons :scrId="scrId"></buttons>
				<div class="d-flex w-100 h-100" style="flex-direction: row; justify-content: space-between">
					<sf-card class="p-0 border-0 bg-transparent mt-5" style="width: 55%">
						<table-view ref="leftTable" @Refresh="refresh" :scrId="scrId"></table-view>
					</sf-card>
					<!-- 좌, 우 화살표 -->
					<div style="width: 5%; display: flex; align-items: center; justify-content: center">
						<div style="width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center">
							<sf-button line class="icon-sf-caret-right" style="margin: 0 0 10px 0" :onClick="onRight" />
							<sf-button line class="icon-sf-caret-left" style="margin: 10px 0 0 0" :onClick="onLeft" />
						</div>
					</div>
					<sf-card class="p-0 border-0 bg-transparent mt-5" style="width: 35%">
						<table-detail ref="rightTable" @Refresh="refresh" :scrId="scrId"></table-detail>
					</sf-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';

import SearchView from './Search/Search';
import TableView from './Table/Table';
import TableDetail from './Table/TableDetail';
import Buttons from './Table/Buttons';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { isloaded: false };
	},
	async created() {
		try {
			this.isloaded = false;
			this.$sf_toggleLoading(true);
			await this.getCommCodes_({ key: 'ipnWayList', codeType: 'IPN_WAY' });
			await this.getCommCodes_({ key: 'lgrpList', codeType: 'LGRP' });
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });
			await this.getAllSgrpList_();
			this.setState_({ key: 'isPqyUser', value: await this.inclManyUsrGrp_(['PQYAP', 'PQYRV', 'PQYRG', 'OS']) });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isloaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, TableDetail, Buttons },
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		onLeft() {
			const selectedRows = this.$refs.rightTable.getSelectedRows();
			let copyList = [...this.detailList];
			for (const row of selectedRows) {
				copyList = copyList.filter(el => !(el.lgrpCd === row.lgrpCd && el.sgrpCd === row.sgrpCd));
			}
			this.setDetailList_({ status: 'del', changeArr: copyList });
		},
		onRight() {
			if (this.searchParams.custCd == '') {
				this.$sf_showMessage({
					icon: 'error',
					message: this.getMessage_('QWCC001352')
				}); //업체를 먼저 조회해주세요.
				return;
			}
			const selectedRows = this.$refs.leftTable.getSelectedRows();
			const tempArr = [];
			for (const row of selectedRows) {
				const resultInt = this.detailList.filter(el => el.lgrpCd === row.lgrpCd && el.sgrpCd === row.sgrpCd).length;
				row.rnum = '';
				resultInt === 0 && tempArr.push(row);
			}
			this.setDetailList_({ status: 'add', changeArr: tempArr });
			this.$refs.leftTable.getClearSelection();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style></style>
